// utils/getLogoUrl.js
import { buildS3Url } from 'utils/s3Utils';

export const getFundInitial = (fund) => {
    const name =
        fund?.fundName ||
        fund?.morningStarName ||
        fund?.schemeName ||
        fund?.name ||
        fund?.bankName ||
        fund?.displayName ||
        "";

    return name ? name.charAt(0).toUpperCase() : "F";
};

export const getLogoUrl = (fund) => {
    const logo = fund?.amcLogo || fund?.logo || fund?.fundLogo;
    return buildS3Url(logo);
};